import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllCustomerOrderLinesDataGrid } from "src/components/views/erp/sales/customerOrderLine/AllCustomerOrderLinesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/allCustomerOrderLines")({
	staticData: { title: i18n.t("all_customer_order_lines"), legacyViewKey: "allCustomerOrderLinesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllCustomerOrderLinesDataGrid />;
}
